import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { businessRequest, TOKEN_KEY } from '@/lib/businessApi';
import { deviceTimezone } from '@/lib/deviceTimezone';

export default function BusinessTimezoneSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    let saved, pending = false, stopped = false;
    const sync = async () => {
      const token = localStorage.getItem(TOKEN_KEY), timezone = deviceTimezone();
      if (!token || !timezone || saved === token + timezone || pending || stopped || document.hidden) return;
      pending = true;
      try {
        await businessRequest('/users/me/timezone', {method:'PUT', token, body:{timezone}});
        if (!stopped) saved = token + timezone;
      } catch { /* Retry on focus/next tick without interrupting the workspace. */ }
      finally { pending = false; }
    };
    void sync();
    const timer = setInterval(sync, 60000);
    window.addEventListener('focus', sync);
    document.addEventListener('visibilitychange', sync);
    return () => { stopped = true; clearInterval(timer); window.removeEventListener('focus', sync); document.removeEventListener('visibilitychange', sync); };
  }, [pathname]);
  return null;
}
